import { useContext } from "react";
import useSWR from "swr";
import { CustomersChasablesApiResponse } from "@attelas/shared";
import { environment } from "../config/environment";
import { ToastContext } from "../context/ToastContext";
import { useSWRFetcher } from "./useSWRFetcher";
import { TenantContext } from "../context/TenantContextProvider";

/**
 * Fetches the list of customer chasables from the REST API.
 * Uses GET /api/contacts/customers/chasables with Business-Tenant from context.
 * For SignalR-based customer chasables, use useCustomerChasables instead.
 */
export function useCustomersChasablesApi() {
  const fetcher = useSWRFetcher();
  const { showToast } = useContext(ToastContext);
  const { tenant: currentTenantId } = useContext(TenantContext);

  const { data, isLoading, error, mutate } = useSWR<CustomersChasablesApiResponse>(
    currentTenantId ? ["customers-chasables-api", currentTenantId] : null,
    ([, tenantId]: [string, string]) =>
      fetcher(`${environment.apiUrl}/api/contacts/customers/chasables`, {
        headers: { "Business-Tenant": tenantId },
      }),
    {
      onError: () => {
        showToast("Failed to load chasables, please try again later", "error");
      },
    }
  );

  return {
    chasables: data?.chasables ?? [],
    lastUpdated: data?.lastUpdated,
    isLoading,
    isError: !!error,
    mutate,
  };
}
